module.exports = __webpack_public_path__ + "media/react/payments/pages/add_ons/assets/admissions/headshot_taryn-abb79b4a89e4df6738a5108e879dee56.jpg";